import WarehouseService from "@/services/warehouse/warehouse.service";

export const warehouse = {
    namespaced: true,
    state: { list:[] , error:false, rooms: [], tmpRoom:null, sensors:[], selectedSensor:null, temperatureData:[], room:null, markers: [], addableMarkers: [], renamedSensor: null, lastTransmissions:[] },
    actions: {
        getWarehouseList({ commit, state }, force = false){
            if (!force && state.list?.data?.list?.length) {
                return Promise.resolve(); // Skip fetch
            }

            return WarehouseService.getWarehouseWithSensorAndRooms()
                .then(
                    warehouses => {
                        commit('warehouseListFetchSuccess', warehouses);
                    },
                    error => {
                        commit('fetchingFail', error);
                    }
                )
        },
        getAllLastTransmissions({ commit }) {
            return WarehouseService.getAllLastTransmissions().then(
                lastTransmissions => {
                    commit('getLastTransmissions', lastTransmissions.data)
                },
                error => {
                    commit('fetchingFail',error)
                }
            )
        },
        getWarehouseRooms( { commit }, warehouseId ){
            return WarehouseService.getWarehouseRooms(warehouseId).then(
                room => {
                    commit('warehouseRoomsFetchSuccess', room)
                },
                error => {
                    commit('fetchingFail',error)
                }
            )
        },
        updateRoom({ commit }, data){
          return WarehouseService.updateRoom(data).then(
              room => {
                  commit('warehouseRoomUpdateSuccess', room)
              },
              error => {
                  commit('fetchingFail', error)
              }
          )
        },
        updateWarehouse({ commit }, data){
            return WarehouseService.updateWarehouse(data).then(
                data => {
                    commit('warehouseUpdateSuccess', data)
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        },
        updateSensorName({ commit }, formData){
          return WarehouseService.updateSensorName(formData).then(
              sensor => {
                  commit('renameSensor', sensor)
              },
              error => {
                  commit('fetchingFail', error)
              }
          )
        },
        roomMarkerList({ commit }, controllerId){
          return WarehouseService.markerList(controllerId).then(
              markers => {
                  commit('fetchingMarkersSuccess', markers)
              },
              error => {
                  commit('fetchingFail', error)
              }
          )
        },
        addableMarkerList({ commit }, imei){
            return WarehouseService.addableMarkerList(imei).then(
                addableMarkers => {
                    commit('fetchingAddableMarkerSuccess', addableMarkers)
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        },
        updateRoomMapSensorMarkers({ commit }, data){
          return WarehouseService.updateRoomSensorMarkers(data)
              .then(
                  success =>{
                      commit('successMapMarkerUpdate',success)
                  },
                  error =>{
                      commit('fetchingFail', error)
                  }
              )
        },
        // eslint-disable-next-line no-unused-vars
        removeMarkerFromRoom({ commit }, sensorId){
          return WarehouseService.removeRoomMarker(sensorId)
              .then(
                  success => {
                      commit( 'successSensorRemove' ,success)
                  }
              )
        },
        updateRoomMapPicture({ commit }, formData){
            return WarehouseService.updateRoomMapPicture(formData).then(
                room => {
                    commit('warehouseRoomUpdateSuccess', room)
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        },
        removeRoomPicture({ commit }, roomId){
          return WarehouseService.removeRoomPicture(roomId).then(
              room => {
                  commit('warehouseRoomUpdateSuccess', room)
              },
              error => {
                  commit('fetchingFail', error)
              }
          )
        },
        getWarehouseRoomSensors({ commit }, roomId){
            return WarehouseService.getWarehouseRoomSensors(roomId).then(
                sensors => {
                    commit('warehouseRoomSensorFetchSuccess', sensors)
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        },
        setSelectedSensor({ commit }, sensor){
            commit('selectedSensor', sensor)
        },
        fetchSensorTemperatureData({ commit }, sensorId){
            return WarehouseService.getSensorTemperatureData(sensorId).then(
                 temperatureData => {
                     commit('sensorTemperatureDataFetchSuccess', temperatureData)
                 },
                error => {
                     commit('fetchingFail',error)
                }
            )
        }
    },
    mutations: {
        fetchingFail(state, error) {
            state.error = error
        },
        warehouseListFetchSuccess(state,warehouses) {
            state.list = warehouses
        },
        warehouseRoomsFetchSuccess(state, rooms){
            state.rooms = rooms
        },
        warehouseUpdateSuccess(state, data) {
            const warehouse = state.list.data.list.find(
                item => item.id === data.data.warehouse.id
            );
            if (warehouse) {
                warehouse.name = data.data.warehouse.name;
            }
        },
        successMapMarkerUpdate(state,room){
            state.sensors.sensors.push(room.data.sensor)
        },
        successSensorRemove(state, sensor){
            let index = state.sensors.sensors.findIndex(item => item.id === parseInt(sensor.data.sensor.id));
            state.sensors.sensors.splice(index, 1);
        },
        warehouseRoomSensorFetchSuccess(state, sensors){
            if (Array.isArray(sensors.data.list)){
                let sensArr = []
                sensors.data.list.forEach((item) => {
                    item.sensors.forEach((sItem) => {
                        sensArr.push(sItem)
                    })
                })
                state.sensors = {
                    ...sensors.data.list[0],
                    sensors: sensArr
                }
            }else{
                state.sensors = sensors.data.list
            }
        },
        selectedSensor(state, sensor){
            state.selectedSensor = sensor
        },
        getLastTransmissions(state, data) {
          state.lastTransmissions = data
        },
        renameSensor(state, sensor){
            state.renamedSensor = sensor
        },
        sensorTemperatureDataFetchSuccess(state, temperatureData){
            state.temperatureData = temperatureData
        },
        fetchingMarkersSuccess(state ,markers){
            state.markers = markers
        },
        fetchingAddableMarkerSuccess(state, addableMarkers){
            state.addableMarkers = addableMarkers
        }
    }

}